module.exports = __webpack_public_path__ + "static/14-de5922a431ef4aa4c339928710a29c6b.jpg";